import Response from "../../Data/Domain/Response";
import Report from "../Domain/Report";
import { getReport } from "./Reports.service";

export async function getReportRepository(type, filter) {
  const data = await getReport(type, filter);
  return new Response(data, Report).getSingle();
}
